import { axios } from '@/utils/axios';
import type { NotificationCenterItem, NotificationCenterPage } from '@/types/notifications';

type NotificationListParams = {
  archived?: boolean;
  q?: string;
  cursor?: string | null;
  page?: number;
  perPage?: number;
};

export const getUserNotifications = ({ archived = false, q = '', cursor = null, perPage = 20 }: NotificationListParams = {}) =>
  axios.get<{ success: boolean; data: NotificationCenterPage; message: string }>('/api/notification-center/cursor', {
    params: { archived: archived ? 1 : 0, q: q || undefined, cursor: cursor || undefined, per_page: perPage },
  });

export const openNotification = (id: number) =>
  axios.post<{ success: boolean; data: NotificationCenterItem; message: string }>(`/api/notification-center/${id}/open`);

export const archiveNotifications = (ids: number[]) =>
  axios.post('/api/notification-center/archive', { ids });

export const unarchiveNotifications = (ids: number[]) =>
  axios.post('/api/notification-center/unarchive', { ids });
